import axios from 'axios';

// for developement
// const baseURL = 'http://localhost:6491/api/';

//  for AI ENTERPRISE DEmo
//  const baseURL = 'http://targetdemo.asktek.net/ob.aienterprise.demo.webapi/api/';

//  const baseURL = 'http://targetdemo.asktek.net/quickob.growwellimpex.demo.webapi/api/';

// for AI ENTERPRISE Testing .
//  const baseURL = 'http://targettest.asktek.net/ob.aienterprise.testing.webapi/api/';

// for AI Enterprise LIVE
const baseURL = 'https://live.asktek.net/ob_ai_enterprise_webapi/api/';


const instance = axios.create({
  baseURL,
});

export default {
  instance,
  baseURL,
};
